/** Minutes status ids of a written / video session (`minutesStatusId` of the session details, LEG-251 / LEG-253). */
export enum InvestigationMinutesStatusId {
	Drafting = 1,
	AwaitingAttestation = 2,
	Attested = 3,
}
